import { banco } from '../db/banco'
import { novoRegistroBase, agoraISO } from '../db/tipos'
import type { ConfiguracaoMetas, Meta } from '../db/tipos'
import { gravarLocalEEnfileirar } from '../sync/outbox'

export interface Passos {
  pctDinheiro: number
  pontosCobertura: number
  passoItensPorPedido: number
}

export interface ConfigDeMetas extends Passos {
  tiposAtivos: Meta['tipo'][]
}

export const TODOS_OS_TIPOS: Meta['tipo'][] = [
  'valor_vendido', 'positivacao', 'itens_por_pedido',
  'cobertura_linhas', 'comissao_necessaria', 'faturamento_total',
]

// ⭐ O padrao existe para ela NAO ter de configurar nada. Estes numeros sao
// decisao dela (spec §6): +15% nas de dinheiro, +3 pontos na cobertura,
// +0,3 em itens por pedido.
export const PADRAO_METAS: ConfigDeMetas = {
  pctDinheiro: 15,
  pontosCobertura: 3,
  passoItensPorPedido: 0.3,
  tiposAtivos: TODOS_OS_TIPOS,
}

async function linhaAtual(): Promise<ConfiguracaoMetas | undefined> {
  const linhas = await banco.configuracao_metas.filter((c) => c.apagado_em === null).toArray()
  return linhas[0]
}

// ⚠ O ramo do PADRAO devolve COPIA, com o array clonado. Devolver a referencia
// deixava quem chama corromper o padrao do modulo: uma tela que fizesse
// "rascunho = await lerConfiguracao()" e mexesse no rascunho estragava TODAS as
// leituras seguintes ate recarregar a pagina -- e a garantia de que "a sugestao
// chega pronta com padrao bom" morria sem erro nenhum na tela.
//
// O ramo da LINHA GRAVADA nao precisa de copia: o IndexedDB devolve um objeto
// novo a cada leitura, entao mutar o que veio nao contamina a leitura seguinte.
// Medido em 2026-08-05 tirando o clone e rodando o teste isolado -- ele passou
// mesmo assim, o que provava que o cenario nao existe e que um teste ali seria
// falso-verde.
export async function lerConfiguracao(): Promise<ConfigDeMetas> {
  const linha = await linhaAtual()
  if (!linha) return { ...PADRAO_METAS, tiposAtivos: [...PADRAO_METAS.tiposAtivos] }
  return {
    pctDinheiro: linha.pct_dinheiro,
    pontosCobertura: linha.pontos_cobertura,
    passoItensPorPedido: linha.passo_itens_por_pedido,
    tiposAtivos: linha.tipos_ativos,
  }
}

export async function gravarConfiguracao(valores: ConfigDeMetas): Promise<void> {
  // Reusar a linha existente e o que mantem UMA configuracao por tenant. Um
  // novoRegistroBase() aqui criaria uma segunda linha a cada salvamento, e a
  // tela passaria a ler a errada.
  const base = (await linhaAtual()) ?? novoRegistroBase()
  await gravarLocalEEnfileirar('configuracao_metas', {
    ...base,
    atualizado_em: agoraISO(),
    pct_dinheiro: valores.pctDinheiro,
    pontos_cobertura: valores.pontosCobertura,
    passo_itens_por_pedido: valores.passoItensPorPedido,
    tipos_ativos: valores.tiposAtivos,
  })
}
